import { Injectable, Injector } from '@angular/core';
import { DwMetaDataFormPreferences } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { QuestionFormLayoutVariant } from '../models/question-form-layout.model';
import { quizFormLayout } from '../models/quiz-form-layout';
import { QuestionFormLayoutWidgetRegistrationService } from './question-form-layout-widget-registration.service';

@Injectable({ providedIn: 'root' })
export class QuizFormLayoutWidgetRegistrationService extends QuestionFormLayoutWidgetRegistrationService {
  protected readonly formConfigKey = 'Quiz-edit-quiz';
  protected readonly layoutWidgetKey = 'Quiz-layout';
  protected readonly layoutClass = 'qe-layout';

  protected get formConfigKeys(): string[] { return ['Quiz', this.formConfigKey]; }

  constructor(injector: Injector) {
    super(injector);
  }

  protected loadLayout(variant: QuestionFormLayoutVariant): Observable<{ section: any }> {
    const preferences = this.uiConfigService.getFinalPreferences<DwMetaDataFormPreferences>(this.state.hierarchy);
    return of({ section: quizFormLayout(preferences.section, variant.key === 'redesign', this.activeFormConfigKey === 'Quiz') });
  }
}
